module.exports = __webpack_public_path__ + "static/img/defult.6e707e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/defult.png
// module id = 7N4W
// module chunks = 1